/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Blank_LinesInputs */



/**
* | output |
* | --- |
* | "Blank lines" |
*
* @param {Qc_Fix_Blank_LinesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_blank_lines = /** @type {((inputs?: Qc_Fix_Blank_LinesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Blank_LinesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes vides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Zeilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Righe vuote")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пустые строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Líneas en blanco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("空行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली पंक्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas em branco")
	return /** @type {LocalizedString} */ ("Blank lines")
});